import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TaggingOptions, UiKitModule } from '@serviceplan/ui-kit';
import { UserInfo } from '@thehubz/client/data-access-api';

@Component({
  selector: 'thehubz-asset-notes-dialog',
  templateUrl: './asset-notes-dialog.component.html',
  styleUrls: ['./asset-notes-dialog.component.scss'],
  standalone: true,
  imports: [FormsModule, MatIconModule, MatDialogModule, UiKitModule],
})
export class AssetNotesDialogComponent implements OnInit {
  taggingOptions: TaggingOptions = {
    roles: ['global.library', 'asset.update'],
  };
  taggedUser!: UserInfo[]; // tagged user list
  descriptionText!: string; // sp-editor description text
  notes!: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: { notes: string },
    private readonly dialogRef: MatDialogRef<AssetNotesDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.notes = this.data.notes;
  }

  submit() {
    this.dialogRef.close(this.notes);
  }

  /**
   * store tagged user list when user tagged get at sp-editor
   * @param userList
   */
  taggedUserList(userList: UserInfo[]) {
    this.taggedUser = userList;
  }
  /**
   * store description text from sp-editor change
   * @param descriptionText
   */
  editorDescriptionText(descriptionText: string) {
    this.descriptionText = descriptionText;
  }

  onNotesChange(value: string) {
    this.notes = value;
  }
}
